import React from "react";
import { RadioBlock } from "./styled";
import { Text } from "../../../styled";
import { useHistory } from "react-router";
import {
  createEventObjectFunction,
  fadeOutFunction,
} from "../../../utils/helper";
import { onboardingFillEventAmplitude } from "../../../amplitude/events";
import { onboardingFillEvent } from "../../../firebaseAnalytics/events";
import { analytics } from "../../../firebaseAnalytics";

const Radio = (props) => {
  const {
    text,
    value,
    isActive,
    setActiveRadio,
    index,
    nextRoute,
    currentRoute,
    noteAnswer,
    fadeOutAdded,
    eventFillName,
    landingId,
    advEventProperty,
  } = props;
  const history = useHistory();

  const handleRadioClick = (index, value) => {
    let advEventObj = {};
    if (advEventProperty) {
      advEventObj[advEventProperty] = text;
    }
    setActiveRadio(index);
    noteAnswer(currentRoute, [value]);
    fadeOutFunction();
    setTimeout(() => setActiveRadio(null), 300);
    const eventObj = createEventObjectFunction(
      eventFillName,
      null,
      landingId,
      advEventObj
    );
    // Событие №4 fill
    onboardingFillEvent(analytics, eventObj);
    onboardingFillEventAmplitude(eventObj);
    setTimeout(() => {
      history.push(nextRoute);
    }, 500);
  };

  return (
    <RadioBlock
      isActive={isActive}
      onClick={() => handleRadioClick(index, value)}
    >
      <Text>{text}</Text>
    </RadioBlock>
  );
};

export default Radio;
